import styled from 'styled-components';

export const SingleCellFooterStyled = styled.tfoot``;
